import type { Category } from '../../sharedTypes';
import { CATEGORIES, type ReceiveCategoriesAction } from '../actions/categoriesActions';

export type CategoriesState = {
  categories: Array<Category>;
};

export const categoriesInitialState: CategoriesState = {
  categories: [],
};

export function categoriesReducer(
  state: CategoriesState = categoriesInitialState,
  action: ReceiveCategoriesAction,
): CategoriesState {
  switch (action.type) {
    case CATEGORIES.RECEIVE_CATEGORIES: {
      const { categories } = action;
      return {
        ...state,
        categories,
      };
    }

    default: {
      return state;
    }
  }
}

// these categories are always displayed
export const staticCategories: Array<Category> = [
  {
    id: null,
    name: 'All',
    children: [],
  },
  {
    id: 'mycart',
    name: 'My Cart',
    children: [],
  },
  {
    id: 'myfavorites',
    name: 'My Favorites',
    children: [],
  },
];
